export default [
  // 转让管理员
  {
    name: 'transfer-manager',
    component: () => import(/* webpackChunkName: "transferManagerPopup" */ './transfer-manager.vue'),
  },
  // 设置密码
  {
    name: 'set-password',
    component: () => import(/* webpackChunkName: "setPasswordPopup" */ './set-password.vue'),
  },
  // 修改密码
  {
    name: 'change-password',
    component: () => import(/* webpackChunkName: "changePasswordPopup" */ './change-password.vue'),
  },
];
